import { createAction } from 'redux-actions';
import { updateLeaseMutationGQL } from './graphql';
import { createLease } from './graphql/createLeaseMutation';

export const types = {
  OPEN_LEASE_EDIT_MODAL: 'admin/leaseList/OPEN_LEASE_EDIT_MODAL',
  CLOSE_LEASE_EDIT_MODAL: 'admin/leaseList/CLOSE_LEASE_EDIT_MODAL',

  OPEN_LEASE_MOVE_MODAL: 'admin/leaseList/OPEN_LEASE_MOVE_MODAL',
  CLOSE_LEASE_MOVE_MODAL: 'admin/leaseList/CLOSE_LEASE_MOVE_MODAL',

  OPEN_LEASE_MERGE_MODAL: 'admin/leaseList/OPEN_LEASE_MERGE_MODAL',
  CLOSE_LEASE_MERGE_MODAL: 'admin/leaseList/CLOSE_LEASE_MERGE_MODAL',

  OPEN_LEASE_ADD_MODAL: 'admin/leaseList/OPEN_LEASE_ADD_MODAL',
  CLOSE_LEASE_ADD_MODAL: 'admin/leaseList/CLOSE_LEASE_ADD_MODAL',
};

export const openLeaseEditModal = createAction(types.OPEN_LEASE_EDIT_MODAL);
export const closeLeaseEditModal = createAction(types.CLOSE_LEASE_EDIT_MODAL);

export const openLeaseMoveModal = createAction(types.OPEN_LEASE_MOVE_MODAL);
export const closeLeaseMoveModal = createAction(types.CLOSE_LEASE_MOVE_MODAL);

export const openLeaseMergeModal = createAction(types.OPEN_LEASE_MERGE_MODAL);
export const closeLeaseMergeModal = createAction(types.CLOSE_LEASE_MERGE_MODAL);

export const openLeaseAddModal = createAction(types.OPEN_LEASE_ADD_MODAL);
export const closeLeaseAddModal = createAction(types.CLOSE_LEASE_ADD_MODAL);

export const dispatchUpdateLease = (lease, customerId, taxScheduleId) => {
  return async (dispatch, getState, { client }) => {
    await updateLeaseMutationGQL(client, lease, customerId, taxScheduleId);
    dispatch(closeLeaseEditModal());
  };
};

export const dispatchCreateLease = (operatorId, leaseName) => {
  return async (dispatch, getState, { client }) => {
    await createLease(client, operatorId, leaseName);
  };
};
